import React from 'react';
import { useSelector } from 'react-redux';
import { Select, Form } from 'ui/components';
import cn from 'classnames';

const initialState = {
  driver: null,
  bank_account: '',
  name: '',
  phone_number: '',
  vehicle_number: '',
  vehicle_type: null,
  vehicle: null
};

export const FormLand = ({
  onValueChange,
  vendor,
  initialValue,
  removePadding,
}) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { driver, bank_account, name, phone_number, vehicle_number, vehicle_type, vehicle },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const value = {
      driver_id: driver?.id,
      bank_account,
      name,
      phone_number,
      vehicle_number,
      vehicle_type_id: vehicle_type?.id,
      vehicle_id: vehicle?.id,
    };
    onValueChange(value);
  }, [driver, bank_account, name, phone_number, vehicle_number, vehicle_type, vehicle]);

  React.useEffect(() => {
    if (!initialValue) return;
    setState((prevState) => ({
      ...prevState,
      driver: initialValue?.driver,
      bank_account: initialValue?.driver?.bank_account,
      name: initialValue?.driver?.name,
      phone_number: initialValue?.driver?.phone,
      vehicle_number: initialValue?.vehicle_number,
      vehicle_type: initialValue?.vehicle_type,
      vehicle: initialValue?.vehicle,
    }));
  }, [initialValue]);

  return (
    <div className={cn(removePadding ? 'p-0' : 'p-3', 'h-100')}>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <Select.Remote
              label="Pilih Driver"
              placeholder=""
              url="/tms/driver"
              value={driver}
              initialValue={initialValue?.driver?.id}
              row={(d) => {
                return {
                  value: d.id,
                  label: `${d.name} - ${d.phone?.replaceAll('-', '')}\n${
                    d?.vehicle_number
                  }`,
                };
              }}
              onSelected={(c) => {
                setState((prevState) => ({
                  ...prevState,
                  driver: c,
                  bank_account: c?.bank_account,
                  name: c?.name,
                  phone_number: c?.phone,
                  vehicle_number: c?.vehicle_number,
                }));
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <Select.Remote
              required
              label="Pilih Kendaraan"
              placeholder=""
              url="/tms/vehicle"
              initialValue={initialValue?.vehicle?.id}
              params={{ sort_by: 'name' }}
              row={(d) => {
                return {
                  value: d.id,
                  label: d?.code,
                };
              }}
              onSelected={(e) =>
                setState((prevState) => ({ ...prevState, vehicle: e, vehicle_number: e?.vehicle_number }))
              }
              errors={StateForm?.errors['land_freight.vehicle_id']}
            />
          </div>
          {!vehicle && (
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Jenis Kendaraan"
                placeholder=""
                url="/tms/vehicle/type"
                initialValue={initialValue?.vehicle_type?.id}
                params={{ sort_by: 'name' }}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d?.karoseri_type
                      ? `${d?.name} - ${d?.karoseri_type}`
                      : `${d?.name}`,
                  };
                }}
                onSelected={(e) =>
                  setState((prevState) => ({ ...prevState, vehicle_type: e }))
                }
                errors={StateForm?.errors['land_freight.vehicle_type_id']}
              />
            </div>
          )}
        </div>
        <div className="border-bottom mb-3 pb-2">
          <small className="form-hint fw-medium">Atau tambah driver baru</small>
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={name}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                name: e.target.value,
              }))
            }
            type="text"
            label="Nama Driver "
            error={StateForm?.errors['land_freight.name']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={phone_number}
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                phone_number: e.target.value,
              }));
            }}
            type="phone"
            label="Nomor HP Driver"
            error={StateForm?.errors['land_freight.phone_number']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={vehicle_number}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                vehicle_number: e.target.value,
              }))
            }
            type="text"
            label="No. Polisi"
            error={StateForm?.errors['land_freight.vehicle_number']}
          />
        </div>
      </div>
    </div>
  );
};
